import { useUnhappyStates } from './useUnhappyStates';
import { useLocation } from 'react-router';
import {
  PaywallRoutes,
  RoutesThatRequireDefaultCreationEnvConnection,
  RoutesThatRequireInitialFetch,
} from '../../../constants/appRoutes';
import { EnvConnectionErrorPage } from './env-connection-error-page/EnvConnectionErrorPage';
import FetchingPage from '../../dashboard/fetching-env-page/FetchingPage';
import PaywallPageBlock from '../../dashboard/paywall/sales-activated-trial/PaywallPageBlock';
import { ConnectToSfPage } from '../../dashboard/paywall/sales-activated-trial/ConnectToSfPage';
import usePaywall from '../../dashboard/paywall/usePaywall';

export const WithUnhappyStates = ({ children }: { children: React.ReactNode }) => {
  const { connectionError, noConnectedOrg, isInitialFetch } = useUnhappyStates();
  const { isPaywallActive } = usePaywall();

  const { pathname } = useLocation();
  const isPaywallPageBlock =
    isPaywallActive && PaywallRoutes.some((route) => pathname.startsWith(route));

  const isRouteRequireDefaultCreationEnv = RoutesThatRequireDefaultCreationEnvConnection.some(
    (route) => pathname.startsWith(route),
  );
  const isRenderConnectionError = isRouteRequireDefaultCreationEnv && connectionError;
  const isRenderConnectToSf = isRouteRequireDefaultCreationEnv && noConnectedOrg;

  const isRouteRequireInitialFetch = RoutesThatRequireInitialFetch.some((route) =>
    pathname.startsWith(route),
  );
  const isRenderFetching = isRouteRequireInitialFetch && isInitialFetch;

  if (isPaywallPageBlock) {
    return <PaywallPageBlock />;
  }

  if (isRenderConnectToSf) {
    return <ConnectToSfPage />;
  }

  if (isRenderFetching) {
    return <FetchingPage />;
  }

  if (isRenderConnectionError) {
    return <EnvConnectionErrorPage envConnectionError={connectionError} />;
  }

  return children;
};
